import React from 'react'
import {Lang} from 'yougile-lang'
import {Help} from '@components/common/base/help'
import {DepartmentsEdit} from '@components/departments-edit/departments-edit'
import {Panel} from '../common/panel'

export const CompanyDepartments = ({className}: {className?: string}) => {
  return (
    <Panel
      title={Lang.msg.companies.departmentsTitle}
      header={
        <div className="flex items-center justify-end w-full">
          <Help name="departments" />
        </div>
      }
      className={className}
    >
      <DepartmentsEdit />
    </Panel>
  )
}
